import axios from "axios";

// dev: '' = same-origin relative URLs, proxied to the local backend by the
// Vite dev server (see vite.config.js proxy)
const domain =
import.meta.env.PROD
    ? "https://esl-okr-management-production.up.railway.app"
    : "";


/**
 *
 * @param {string} email
 * @returns {object} user
 */
async function getUserByEmail(email, userDomain, sessionToken) {
  const user = await axios.get(`${domain}/api/user/${userDomain}/${email}`, {
    headers: {
      Authorization: `Bearer ${sessionToken}`,
    },
  });
  return user.data;
}


async function updateNotifications(userId, isNotifications, sessionToken) {
  try {
    const res = await axios.put(`${domain}/api/user/isNotifications/${userId}`, {isNotifications}, {
    headers: {
      Authorization: `Bearer ${sessionToken}`,
    },
    })
    return res.data
  } catch (err) {
    console.log('file: boardService.js:183 -> err:', err)
  }
}


export default {
  getUserByEmail,
  updateNotifications,
};
